<template>
  <div class="content">
    <LinkPath current-path="auditoria de sujeitos"/>
    <section>
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="form-group" style="padding: 1rem; display: grid">
              <div id="divAlert" class="alert alert-success" role="alert" style="margin: 16px; display:none;"></div>

                <div class="form-row input-row" style="align-items: end">
                    <div class="col-md-7 mb-3">
                        <label for="cpf">CPF</label>
                        <input type="text" class="form-control" v-model="cpf" id="cpf" maxlength="11" size="11">
                    </div>

                    <div class="col-md-4 mb-3">
                        <button id="btnPesq" type="button" class="btn btn-primary input-space button-color" v-on:click="search()" >Pesquisar</button>
                        <button type="button" class="btn btn-secondary input-space" v-on:click="clearFilter()" >Limpar Filtros</button>
                    </div>

                </div>

              <div class="form-row">
                <div class="date-box">
                  <div class="col-md-3 mb-3" style="margin-top: 5px;">
                    <label for="dataIni">Data Início</label>
                    <div class="input-group">
                            <span class="input-group-addon date-input">
                                <i class="fa fa-fw fa-calendar"></i>
                            </span>
                      <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtIni"
                                  id="dataIni" width="100%" required></datepicker>
                    </div>
                  </div>
                  <div class="col-md-3 mb-3" style="margin-top: 5px;">
                    <label for="dateFim">Data Fim</label>
                    <div class="input-group">
                            <span class="input-group-addon date-input">
                                <i class="fa fa-fw fa-calendar"></i>
                            </span>
                      <datepicker class="datetime-picker" format="dd/MM/yyyy" :language="ptBR" v-model="dtFim"
                                  id="dateFim" width="100%" required></datepicker>
                    </div>
                  </div>
                </div>
                </div>



                <div style="clear:both;"></div>
            </div>

            <div id="divblank" class="divBlank">
                <div id="divTab" style="display:none;">
                    <div class="row center-block">
                        <div class="col-md-12">
                            <div class="box">

                            <!-- /.box-header -->
                            <div class="box-body">
                                <div class="dataTables_wrapper form-inline dt-bootstrap" id="tabAudit_wrapper">
                                <div class="row">
                                    <div class="col-sm-6">
                                    <div id="tabAudit_length" class="dataTables_length">

                                    </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 table-responsive">
                                    <table aria-describedby="tabAudit" role="grid" id="tabAudit" class="table table-bordered table-striped dataTable">
                                        <thead>
                                        <tr role="row">
                                            <th colspan="1" rowspan="1" aria-controls="tabAudit" tabindex="0">Data/Hora</th>
                                            <th colspan="1" rowspan="1" aria-controls="tabAudit" tabindex="0">CPF</th>
                                            <th colspan="1" rowspan="1" aria-controls="tabAudit" tabindex="0">Usuário</th>
                                            <th colspan="1" rowspan="1" aria-controls="tabAudit" tabindex="0">Ação</th>
                                        </tr>
                                        </thead>
                                    <tbody>
                                        <tr v-for="audit in listAudit" :key="audit.id" class="even" role="row">
                                            <td data-sort="<%= audit.formatDate.strftime('%Y%m%d%H%M%s') %>">{{audit.formatDate}}</td>
                                            <td>{{cpfList}}</td>
                                            <td>{{audit.operator}}</td>
                                            <td>
                                                <a href="#" v-if="audit.operation !== 'DELETE' && check('NIST')" v-on:click="downloadNist(audit.objectId, audit.message)" title="Download Nist">{{audit.operation}}</a>
                                                <a href="#" v-if="audit.operation !== 'DELETE' && !check('NIST')">{{audit.operation}}</a>
                                                <a href="#" v-if="audit.operation === 'DELETE'" v-on:click="getInfo(audit.objectId)" data-toggle="modal" data-target="#infoModal" title="Informações da Exclusão">{{audit.operation}}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="1" rowspan="1">Data/Hora</th>
                                            <th colspan="1" rowspan="1">CPF</th>
                                            <th colspan="1" rowspan="1">Usuário</th>
                                            <th colspan="1" rowspan="1">Ação</th>
                                        </tr>
                                    </tfoot>
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <!-- /.box-body -->
                                <div style="clear:both;"></div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                  <div class="modal-content">
                  <div class="modal-header" style="background-color: #3c8dbc;">
                      <h4 class="modal-title" id="infoModalLabel" style="color: white; font-weight: bold;">Informações da Exclusão</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <div class="form-row">
                        <div style="margin-left: 2.5%;">
                          <div class="form-group" style="float: left;">
                            <label>Motivo</label>
                            <input type="text" v-model="motivo" class="form-control" disabled/>
                          </div>
                           <div class="form-group" style="margin-left: 32%; float: left;">
                            <label>Data/Hora</label>
                            <input type="text" v-model="data" class="form-control" disabled/>
                          </div>
                        </div>
                        <div style="margin-left: 2.5%;">
                          <div class="form-group" style="float: left;">
                            <label>Agente</label>
                            <input type="text" v-model="nomeAgente" class="form-control" disabled/>
                          </div>
                           <div class="form-group" style="margin-left: 32%; float: left;">
                            <label>CPF do Agente</label>
                            <input type="text" v-model="cpfAgente" class="form-control" disabled/>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div class="form-row" style="float: left;">
                        <div class="col-md-4 mb-3" >
                          <div class="form-group">
                            <label>Observação</label>
                            <textarea v-model="obs" rows="6" disabled cols="85">

                            </textarea>
                          </div>
                        </div>
                      </div>
                      <div style="clear:both;"></div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                  </div>
                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import interceptor from '../../interceptor'
import 'datatables.net'
import 'datatables.net-bs'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import roles from '../../roles'
import LinkPath from '../components/LinkPath'

export default {
  name: 'SubjectAudit',
  data: function () {
    return {
      cpf: '',
      dtIni: '',
      dtFim: '',
      cpfList: '',
      listAudit: [],
      ptBR: ptBR,
      motivo: '',
      obs: '',
      nomeAgente: '',
      data: '',
      cpfAgente: '',
      key: 'AUDIT'
    }
  },
  components: {
    LinkPath,
    Datepicker
  },
  methods: {
    check: function(action) {
      return roles.checkrole(window.localStorage.getItem('role'), this.key, action)
    },
    search: function () {
      $('#btnPesq').attr('disabled', true)
      this.clear()
      if (this.cpf === '' || this.cpf === undefined) {
        $('#divAlert').attr('class', 'alert alert-warning')
        .append('<p style="font-weight: bold;">Para efetuar a pesquisa o CPF deve ser informado. </p>')
        .show()
      } else if ((this.dtIni !== '' && this.dtFim === '') || (this.dtFim !== '' && this.dtIni === '')) {
        $('#divAlert').attr('class', 'alert alert-warning')
        .append('<p style="font-weight: bold;">Para pesquisar utilizando um período ambas as datas devem ser preenchidas. </p>')
        .show()
      } else if (this.dtIni > this.dtFim) {
        $('#divAlert').attr('class', 'alert alert-warning')
        .append('<p style="font-weight: bold;">Data Início não pode ser maior que Data Fim. </p>')
        .show()
      } else {
        if (this.dtIni !== '' && this.dtFim !== '') {
          var dtIni = this.formatDate(this.dtIni)
          var dtFim = this.formatDate(this.dtFim)
        }
        interceptor.request('post', 'api/v1/subjects/audit', {cpf: this.cpf, dtIni: dtIni, dtFim: dtFim})
        .then(response => {
          this.cpfList = this.cpf
          this.listAudit = response.data
          /* this.listAudit.sort(function(a, b) {
            return a.id - b.id
          }) */
          if (this.listAudit.length > 0) {
            this.refreshData()
            this.$nextTick(() => {
              $('#tabAudit').DataTable({'oLanguage': {
                'sUrl': '/static/json/languageDataTable.json'
              }
              })
            })
            $('#divblank').attr('class', '')
            $('#divTab').show()
          }
        })
        .catch(function(error) {
          if (error.response.status === 404) {
            $('#divAlert').attr('class', 'alert alert-warning')
            .append('<p style="font-weight: bold;">Não foram encontrados registros para o CPF informado.</p>')
            .show()
          } else {
            $('#divAlert').attr('class', 'alert alert-danger')
            .append('<p style="font-weight: bold;">Erro ao tentar pesquisar os registros. Serviço indisponível.</p>')
            .show()
          }
          this.$nextTick(() => {
            $('#tabAudit').DataTable({'oLanguage': {
              'sUrl': '/static/json/languageDataTable.json'
            }
            }).destroy()
          })
        })
      }
      setTimeout(() => $('#btnPesq').attr('disabled', false), 2000)
    },
    clear: function () {
      $('#divAlert').empty().hide()
      $('#divTab').hide()
    },
    drawDT() {
      $('#tabAudit').DataTable().draw()
    },
    async refreshData() {
      this.isLoading = true
      $('#tabAudit').DataTable().destroy()
      try {
        await this.$nextTick(this.drawDT)
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },
    clearList: function () {
      this.listAudit = []
    },
    downloadNist: function (id, message) {
      if (this.check('NIST')) {
        let url = message === 'TRANSACTION' ? 'api/v1/subjects/transaction/' : 'api/v1/subjects/nist/'
        interceptor.request('get', url + id, {})
        .then(response => {
          var base64 = ''
          var link = document.createElement('a')
          if (message === 'TRANSACTION') {
            link.href = 'data:application/json;text,' + JSON.stringify(response.data)
            link.download = response.data.transactionControlNumber + '.json'
          } else {
            base64 = response.data.nistFileData
            link.href = 'data:application/eft;base64,' + base64
            link.download = response.data.externalId + '.eft'
          }
          document.body.appendChild(link)
          link.click()
          link.remove()
        }).catch(error => {
          console.log(error)
        })
      } else {
        $('#divAlert').attr('class', 'alert alert-danger')
          .append('<p style="font-weight: bold;">Você não tem permissão para executar esta ação. </p>')
          .show()
      }
    },
    getInfo: function (objectId) {
      interceptor.request('get', 'api/v1/subjects/audit/info/' + objectId, {})
      .then(response => {
        this.motivo = response.data.motivo
        this.obs = response.data.obs
        this.nomeAgente = response.data.nome
        this.data = response.data.formatDate
        this.cpfAgente = response.data.cpf
      }).catch(error => {
        console.log(error)
      })
    },
    formatDate: function (date) {
      var day = date.getDate()
      var month = date.getMonth() + 1
      var year = date.getFullYear()
      return day + '-' + month + '-' + year
    },
    clearFilter: function () {
      this.clear()
      this.clearList()
      this.cpf = ''
      this.dtIni = ''
      this.dtFim = ''
      location.reload()
    }
  }
}

</script>

<style>
.date-box {
  display: flex;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}

.divBlank {
   background-color: white;
   height: 400px;
}

.input-space {
  height: 33px;
}
.alert-warning {
  background-color: #7030C5 !important;
}
</style>



// WEBPACK FOOTER //
// SubjectAudit.vue?37981ddb